import Bowser, { Parser } from 'bowser';
import { EventType } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';

export default class SessionStartedEvent implements EventData {
  private browser: Parser.Parser;

  constructor() {
    this.browser = Bowser.getParser(window.navigator.userAgent);
  }

  // eslint-disable-next-line camelcase
  event_type = EventType.sessionStarted;

  // eslint-disable-next-line camelcase
  get event_context(): Record<string, string> {
    return {
      os_name: this.browser.getOSName(),
      os_version: this.browser.getOSVersion(),
      user_agent: this.browser.getUA(),
      browser: this.browser.getBrowserName(),
      browser_version: this.browser.getBrowserVersion(),
    };
  }
}
